/**
 * AXBoot uploader
 */
axboot.uploaderView = {
    uploadedFiles: function () {
        return this.target.uploadedFiles;
    },
    removeFileAll: function () {
        this.target.removeFileAll();
    },
    clear: function () {
        this.target.clear();
        //this.target.loadUploaded();

        if (this.target.hasOwnProperty('uploadedGridBox') && !ax5.util.isNothing(this.target.uploadedGridBox)) {
            this.target.uploadedGridBox.setData({
                list: [],
                page: {
                    currentPage: 0,
                    pageSize: 0,
                    totalElements: 0,
                    totalPages: 0
                }
            });
        }
    },
    getStorageId: function () {
        return this.target.getStorageId();
    },
    getAttachId: function () {
        return this.target.getAttachId();
    },
    setAttachId: function (attachId) {
        this.clear();

        if (this.target.getAttachId() != attachId) {
            this.target.setAttachId(attachId);
        }

        if (!ax5.util.isNothing(attachId)) {
            this.target.loadUploaded();
        }
    },
    setUploadedFiles: function (data) {
        this.target.setUploadedFiles(data);
    },
    setParams: function (param) {
        this.target.setParams(param);
    }
}